<div class="template-assign-container">
  <ul class="nav nav-pills" role="tablist">
    @if (canEditTemplateTab()) {
      <li [class.active]="activeTab === 1">
        <a (click)="openTab(1)" style="cursor: pointer;" class="btn-sm">Edit Template</a>
      </li>
    }
    <li [class.active]="activeTab === 2" [class.disabled]="showImport">
      <a (click)="openTab(2)" style="cursor: pointer;" class="btn-sm">Assign Template</a>
    </li>
    <li [class.active]="activeTab === 3" [class.disabled]="showImport">
      <a (click)="openTab(3)" style="cursor: pointer;" class="btn-sm">Unassign Template</a>
    </li>
  </ul>
  <div class="tab-content" style="overflow-y: auto; max-height: calc(100vh - 235px); padding-top: 15px;">
    <!-- Tab 1: Edit Template -->
    @if (activeTab === 1) {
      <div class="tab-pane active">
        <hr />
        <div class="container-border">
          <div class="panel-body taskActivityInnerBlock">
            <div class="col-md-2 tasksPanel">
              <div class="row" style="margin: 0;">
                <div class="col-md-7" style="padding-left:0">
                  <select class="form-control input-sm" [(ngModel)]="selectedAppClient" (ngModelChange)="loadChannel($event?.client_key)" name="selectedClient">
                    @for (client of clients; track client) {
                      <option [ngValue]="client">{{ client.client_name }}</option>
                    }
                  </select>
                </div>
                <div class="col-md-5" style="padding-left:0;margin-top: 4px;">
                  <button class="btn btn-success btn-xs" (click)="addTemplate()">New Template</button>
                </div>
              </div>
              <div class="row" style="padding-bottom: 5px; padding-top: 5px; margin: 0;">
                <div class="col-md-12" style="padding: 0;">
                  <input type="text" class="form-control" style="height: 25px;" [(ngModel)]="searchText" placeholder="Key Search" name="searchText" />
                  <i class="fa fa-search key-search-icon"></i>
                </div>
              </div>
              <div class="col-border">
                @for (group of filteredTemplatesGroup | keyvalue; track group) {
                  <div>
                    <div class="template-group">{{ getGroupName(group.key) }}</div>
                    @for (template of group.value; track template) {
                      <div class="keyList" [class.selected]="taskModel === template" (click)="selectTaskModel(template)">
                        {{ template.TEMPLATE_NAME }}
                      </div>
                    }
                  </div>
                }
                @if (showTemplateLoader) {
                  <div class="templateLoader"><i class="fa fa-spinner fa-spin"></i></div>
                }
              </div>
            </div>
            <div class="col-md-10">
              @if (showModulesListing) {
                <div class="refreshStep2">
                  <div class="row">
                    <div class="col-md-2"><label>User List:</label></div>
                    <div class="col-md-10 well user-well-xs well-xs" style="padding: 6px;height: 60px;overflow: auto;margin-bottom: 8px;">
                      @for (user of userList; track user) {
                        <div style="margin:0px 5px 5px 0px" class="btn-group btn-group-xs">
                          <div class="btn btn-xs btn-default"><i class="fa fa-user"></i></div>
                          <div class="btn btn-default btn-xs btn-white">{{ user.USER_NAME }}</div>
                        </div>
                      }
                      @if (userList.length === 0) {
                        <div>No User Assigned</div>
                      }
                    </div>
                  </div>
                  <div class="divShadow">
                    <span><strong>Template:</strong>&nbsp;{{ template_data.template_name }}&nbsp;<strong>For</strong>&nbsp;{{ selectedClientName }}</span>
                    <span><strong>Total:</strong>&nbsp;<strong>{{ totalModulesAssigned }}</strong>&nbsp;Modules Selected out of&nbsp;<strong>{{ totalModulesForSelectedClient }}</strong></span>
                  </div>
                  <div class="row panel panel-default" style="margin-top: 8px;margin-left: 0px;">
                    <div class="panel-heading">Application Modules:
                      <select class="form-control input-sm" name="selectedApplication" [(ngModel)]="selectedApplication" (ngModelChange)="setApplication(selectedApplication)" style="width: 120px; display: inline-block; height: 23px; padding: 3px 10px;">
                        @for (item of userAssignNav; track item) {
                          <option [ngValue]="item">{{ item.name }}</option>
                        }
                      </select>
                      <div style="display: inline-flex; float: right;">
                        <button class="btn btn-sm button-lable" (click)="toggleAll()">
                          <span class="fa" [ngClass]="allExpanded ? 'fa-folder' : 'fa-folder-open'"></span>
                          {{ allExpanded ? 'Collapse All' : 'Expand All' }}
                        </button>
                        <input
                          type="text"
                          class="module-search"
                          placeholder="Search Item..."
                          [ngModel]="searchTerm"
                          (ngModelChange)="filterMenu($event)"
                          />
                          <button class="btn btn-success btn-sm" style="margin-left: 8px;" [disabled]="moduleSaveLoading" (click)="saveModuleAssignments()">
                            @if (moduleSaveLoading) {
                              <span><i class="fa fa-spinner fa-pulse"></i></span>
                              }Save Modules
                            </button>
                          </div>
                        </div>
                        <div class="panel-body" style="padding: 0px 0px 10px 0px;">
                          @if (filteredUserAssignNav.length > 0) {
                            <div class="modules-columns">
                              @for (col of moduleColumns; track trackByIndex($index)) {
                                <div class="column">
                                  @for (node of col; track trackByNodeId($index, node)) {
                                    <div class="module-card">
                                      <div class="activity-num" [ngClass]="node._badgeClass">
                                        {{ node._assigned || 0 }}/{{ node._total || 0 }}
                                      </div>
                                      <div class="card-header">
                                        <b class="ellip">{{ node.name }}</b>
                                        <span style="float:right">
                                          <i class="fa fa-user-circle-o user" [title]="node._tooltip"></i>
                                          <i class="fa pls-icon" (click)="toggleNode(node)"
                                          [ngClass]="node.collapsed ? 'fa-plus-square-o' : 'fa-minus-square-o'"></i>
                                        </span>
                                      </div>
                                      <div class="card-assign">
                                        <b>Assign:</b>&nbsp;
                                        <select class="assign-dropdown" [(ngModel)]="node._bulkDropdown"
                                          [ngModelOptions]="{standalone: true}"
                                          (ngModelChange)="applyGroupRole($event, node); node._bulkDropdown = ''">
                                          <option value="" disabled>select Level</option>
                                          <option value="0">No Access</option>
                                          <option value="-1">Lowest Level</option>
                                          <option value="1">Highest Level</option>
                                        </select>
                                      </div>
                                      @if (!node.collapsed && node.children?.length) {
                                        <div class="card-body">
                                          <div class="channel">{{ node.name }}</div>
                                          <div class="user-assign-btn-group">
                                            <button class="btn user-btn" (click)="openUserAccessModal(node)">
                                              <i class="fa fa-user-circle user-icn"></i>Assign User
                                            </button>
                                          </div>
                                          <ng-container *ngTemplateOutlet="treeLevel; context: { $implicit: node }"></ng-container>
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          } @else {
                            <div class="module-list-placeholder">Module list</div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  @if (showModuleLoader) {
                    <div class="moduleLoader"><i class="fa fa-spinner fa-spin fa-2x"></i></div>
                  }
                  @if (!showModuleLoader && !showModulesListing) {
                    <div class="selectModuleMsg">Select Template to view Modules</div>
                  }
                </div>
              </div>
            </div>
          </div>
        }
        <!-- Tab 2: Assign Template -->
        @if (activeTab === 2) {
          <div class="tab-pane active">
            <hr />
            <div class="container-border">
              @if (showOverlayScreen) {
                <div class="taskActivityOverlay">
                  <div class="taskActivitySpinner"><i class="fa fa-spinner fa-spin"></i></div>
                </div>
              }
              <div class="panel-body taskActivityInnerBlock">
                <div class="col-md-2 tasksPanel">
                  <div class="row" style="margin: 0;">
                    <select class="form-control input-sm" [(ngModel)]="selectedAppClient" (ngModelChange)="loadChannel($event?.client_key)" name="selectedClient2">
                      @for (client of clients; track client) {
                        <option [ngValue]="client">{{ client.client_name }}</option>
                      }
                    </select>
                  </div>
                  <div class="row" style="padding-bottom: 5px; padding-top: 5px; margin: 0;">
                    <div class="col-md-12" style="padding: 0;">
                      <input type="text" class="form-control" style="height: 25px;" [(ngModel)]="searchText" placeholder="Key Search" name="searchText2" />
                    </div>
                  </div>
                  <div class="col-border">
                    @for (group of filteredTemplatesGroup | keyvalue; track group) {
                      <div>
                        <div class="template-group">{{ getGroupName(group.key) }}</div>
                        @for (template of group.value; track template) {
                          <div class="keyList">
                            <input type="radio" style="margin-right: 4px;" [name]="'grp_' + group.key" [id]="'tpl_' + template.TEMPLATE_KEY" [checked]="selectedTemplates[group.key] === template.TEMPLATE_KEY" (change)="selectedTemplates[group.key] = template.TEMPLATE_KEY; updateModuleParams('template')" [disabled]="template.disable" />
                            {{ template.TEMPLATE_NAME }}
                          </div>
                        }
                      </div>
                    }
                    @if (showTemplateLoader) {
                      <div class="templateLoader"><i class="fa fa-spinner fa-spin"></i></div>
                    }
                  </div>
                </div>
                <div class="col-md-10">
                  <div class="row">
                    <div class="col-md-2"><label>Search User:</label></div>
                    <div class="col-md-9 assign-search-wrapper" style="padding: 0;margin-bottom: 5px;">
                      <div class="input-group">
                        <input type="text" class="form-control input-sm" placeholder="Type first name, last name or email"
                          [(ngModel)]="userSearchTerm" (input)="onAssignUserSearch()" name="addUser" />
                          <span class="input-group-addon">
                            @if (assignSearching) {
                              <i class="fa fa-spinner fa-pulse"></i>
                            }
                            @if (!assignSearching) {
                              <i class="fa fa-search"></i>
                            }
                          </span>
                        </div>
                        @if (userSearchResults.length > 0) {
                          <div class="search-dropdown">
                            @for (user of userSearchResults; track user) {
                              <a class="search-item" (click)="addAssignUser(user)">{{ user.name }}</a>
                            }
                          </div>
                        }
                        @if (assignNoResults) {
                          <div class="no-results-badge">
                            <i class="fa fa-times"></i> No Results Found
                          </div>
                        }
                      </div>
                      <div class="col-md-1">
                        <button class="btn btn-success btn-sm" style="width: 100%;" (click)="saveUserList()" [disabled]="!assignUserList.length || saveDisabled">Save</button>
                      </div>
                      <div class="col-md-2"><label>User List:</label></div>
                      <div class="col-md-9 well user-well-xs well-xs" style="padding: 6px;height: 216px;overflow: auto;margin-bottom: 8px;">
                        @for (user of assignUserList; track user; let i = $index) {
                          <div style="margin:0px 5px 5px 0px" class="btn-group btn-group-xs">
                            <div class="btn btn-xs btn-default"><i class="fa fa-user"></i></div>
                            <div class="btn btn-default btn-xs btn-white">{{ user.userName }}</div>
                            <div class="btn btn-danger btn-xs" (click)="removeAssignUser(i)"><i class="fa fa-times"></i></div>
                          </div>
                        }
                        @if (assignUserList.length === 0) {
                          <div>No User Assigned</div>
                        }
                      </div>
                      <div class="col-md-1">
                        <button class="btn btn-info btn-sm" style="width: 100%;" (click)="resetUserList()" [disabled]="assignUserList.length === 0">Reset</button>
                      </div>
                    </div>
                    @if (showModuleLoader) {
                      <div class="moduleLoader"><i class="fa fa-spinner fa-spin"></i></div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
          <!-- Tab 3: Unassign Template -->
          @if (activeTab === 3) {
            <div class="tab-pane active">
              <hr />
              <div class="container-border">
                @if (showOverlayScreen) {
                  <div class="taskActivityOverlay">
                    <div class="taskActivitySpinner"><i class="fa fa-spinner fa-spin"></i></div>
                  </div>
                }
                <div class="panel-body taskActivityInnerBlock">
                  <div class="col-md-2 tasksPanel">
                    <div class="row" style="margin: 0;">
                      <select class="form-control input-sm" [(ngModel)]="selectedAppClient" (ngModelChange)="onUnassignClientChange($event)" name="selectedClient3">
                        @for (client of clients; track client) {
                          <option [ngValue]="client">{{ client.client_name }}</option>
                        }
                      </select>
                    </div>
                    <div class="row assign-search-wrapper" style="padding-bottom: 5px; padding-top: 5px; margin: 0;">
                      <div class="input-group">
                        <input type="text" class="form-control input-sm" placeholder="Type first name, last name or email"
                          [(ngModel)]="unassignSearchTerm" (input)="onUnassignUserSearch()" name="addUserUnassign" />
                          <span class="input-group-addon">
                            @if (unassignSearching) {
                              <i class="fa fa-spinner fa-pulse"></i>
                            }
                            @if (!unassignSearching) {
                              <i class="fa fa-search"></i>
                            }
                          </span>
                        </div>
                        @if (unassignSearchResults.length > 0) {
                          <div class="search-dropdown">
                            @for (user of unassignSearchResults; track user) {
                              <a class="search-item" (click)="selectUnassignUser(user)">{{ user.name }}</a>
                            }
                          </div>
                        }
                        @if (unassignNoResults) {
                          <div class="no-results-badge">
                            <i class="fa fa-times"></i> No Results Found
                          </div>
                        }
                      </div>
                      <div style="padding-bottom: 5px; padding-top: 5px; margin: 0;">
                        <div class="well user-well-xs well-xs" style="padding: 6px;height: 216px;overflow: auto;margin-bottom: 8px;">
                          @for (user of unassignUserList; track user) {
                            <div style="margin:0px 5px 5px 0px" class="btn-group btn-group-xs">
                              <div class="btn btn-xs btn-default"><i class="fa fa-user"></i></div>
                              <div class="btn btn-default btn-xs btn-white">{{ user.userName }}</div>
                            </div>
                          }
                          @if (unassignUserList.length === 0) {
                            <div style="text-align: center">Add/Select User</div>
                          }
                        </div>
                      </div>
                      <div>
                        <button class="btn btn-info btn-sm" style="width: 100%;" (click)="clearUser()">Clear User</button>
                      </div>
                    </div>
                    <div class="col-md-10">
                      <div class="row">
                        <div class="col-md-2">
                          <label style="float: right;">Templates List:</label>
                        </div>
                        <div class="col-md-9 well user-well-xs well-xs" style="padding: 6px;height: 400px;overflow: auto;margin-bottom: 8px;">
                          @for (template of allUserTemplates; track template; let i = $index) {
                            <div style="margin:0px 5px 5px 0px" class="btn-group btn-group-xs">
                              <div class="btn btn-default btn-xs btn-white">{{ template.TEMPLATE_NAME }}</div>
                              <div class="btn btn-danger btn-xs" (click)="removeTemplateAt(i)"><i class="fa fa-times"></i></div>
                            </div>
                          }
                          @if (showTemplateLoader) {
                            <div class="moduleLoader"><i class="fa fa-spinner fa-spin"></i></div>
                          }
                          @if (allUserTemplates.length < 1 && !showTemplateLoader) {
                            <div style="text-align: center;margin-top: 60px;">Select user to display templates assigned to them.</div>
                          }
                        </div>
                        <div class="col-md-1">
                          <button class="btn btn-success btn-sm" style="width: 100%;" (click)="saveTemplateList()">Save</button>
                          <button class="btn btn-info btn-sm" style="width: 100%;margin-top: 10px;" (click)="resetTemplateList()">Reset</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

        <ng-template #treeLevel let-parentNode>
          <ul class="tree-structure">
            @for (ch of parentNode.children; track trackByNodeId($index, ch)) {
              <li
                [class.has-children]="ch.children?.length">
                <div class="tree-row">
                  <span class="task">{{ ch.name }}</span>
                  @if (ch.roles?.length > 0) {
                    <div class="pull-right">
                      <select class="child-select"
                        [ngModel]="ch.role?.value != null ? ch.role.value : ch.roles[0]?.value"
                        (ngModelChange)="onNodeRoleValueChange(ch, $event)"
                        [ngModelOptions]="{standalone: true}"
                        [class.has-access]="ch.role?.value > 0">
                        @for (role of ch.roles; track role) {
                          <option [value]="role.value">{{ role.label || role.name }}</option>
                        }
                      </select>
                    </div>
                  }
                </div>
                @if (ch.children?.length) {
                  <ng-container *ngTemplateOutlet="treeLevel; context: { $implicit: ch }"></ng-container>
                }
              </li>
            }
          </ul>
        </ng-template>
